"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const next13_enums_colors_1 = __importDefault(require("@gerenciatd/next13.enums.colors"));
const BuscarIconM = (props) => {
    let { color } = props;
    let layoutSize = {};
    if (props.layoutSize) {
        ({ layoutSize } = props);
    }
    let { width, height, insetPosition } = props;
    const size = {};
    /* damos valor a la otra coordenada en caso de no indicarse */
    if (width && width !== 'auto') {
        if (!layoutSize.width) {
            layoutSize.width = width;
        }
        size.width = width;
    }
    if (height && height !== 'auto') {
        if (!layoutSize.height) {
            layoutSize.height = height;
        }
        size.height = height;
    }
    const fill = (0, next13_enums_colors_1.default)(color);
    return (react_1.default.createElement("div", { className: "svg-layout-size", style: Object.assign({}, layoutSize) },
        react_1.default.createElement("svg", Object.assign({ focusable: "false", viewBox: "0 0 200 200" }, size, { style: Object.assign({}, insetPosition), fill: fill, "aria-label": "", "aria-hidden": "true", role: "presentation" }),
            react_1.default.createElement("path", { d: "M197.6,189l-57.1-57.1c12.5-14.6,19.1-32.5,19.1-51.8c0-21.2-8.3-41.2-23.3-56.3S101.3,0.5,80,0.5S38.9,8.8,23.8,23.8\r\n    S0.5,58.9,0.5,80.1s8.3,41.2,23.3,56.3s35,23.3,56.3,23.3c19.1,0,37.4-6.8,51.8-19.1l57.1,57.1c1.1,1.2,2.8,1.8,4.3,1.8\r\n    c1.6,0,3.2-0.7,4.3-1.8c1.2-1.2,1.9-2.7,1.9-4.3C199.5,191.7,198.8,190.1,197.6,189z M127.7,127.7C115,140.4,98,147.5,80.1,147.5\r\n    s-34.9-7-47.6-19.7C19.8,115,12.7,98.1,12.7,80.1s7-34.9,19.7-47.6S62,12.8,80,12.8s34.9,7,47.6,19.7s19.7,29.6,19.7,47.6\r\n    S140.4,115,127.7,127.7z" }))));
};
exports.default = BuscarIconM;
//# sourceMappingURL=index.js.map